import {api} from "../../services";

const conversations = {
  state: {
    data: [],
    chat: [],
    message: {},
    reply: null
  },
  mutations: {
    SET_CONVERSATIONS(state, payload) {
      state.data = payload
    },
    SET_CONVERSATIONS_CHAT(state, payload) {
      state.chat = payload
    },
  },
  getters: {
  },
  actions: {
    getConversations(context){
      api.get(`/conversations`).then(response => {
        context.commit("SET_CONVERSATIONS", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getConversationsChat(context, payload){
      api.get(`/conversations/${payload.id}`).then(response => {
        context.commit("SET_CONVERSATIONS_CHAT", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    newConversation(context, payload){
      api.post(`/conversations`, payload).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
  },
}
export default conversations;
